"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _now = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/date/now"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactFontawesome = _interopRequireDefault(require("react-fontawesome"));

var _cssConstants = _interopRequireDefault(require("../../../../targets/cord_sanofi/cssConstants.js"));

var _config = _interopRequireDefault(require("../../../../targets/cord_sanofi/config.js"));

var _NuggetFront = _interopRequireDefault(require("./NuggetFront.scss"));

var _KESI2BasicComponent = _interopRequireDefault(require("../../../KESI2/KESI2BasicComponent"));

var _CordovaFileHelper = _interopRequireWildcard(require("../../../helpers/CordovaFileHelper"));

var _DrupalNestedTileSizes = require("./DrupalNestedTileSizes");

var _DeviceInfoHelper = _interopRequireDefault(require("../../../helpers/DeviceInfoHelper"));

var _KESI2Helper = _interopRequireDefault(require("../../../KESI2/KESI2Helper"));

var _Image = _interopRequireDefault(require("../Image/Image"));

var _DataStore = _interopRequireWildcard(require("../../../KESI2/Stores/DataStore2"));

var _FileReaderWriterWrapper = _interopRequireDefault(require("../../../cordovaPluginWrappers/FileReaderWriterWrapper"));

var _FileSystemWrapper = _interopRequireDefault(require("../../../cordovaPluginWrappers/FileSystemWrapper"));

var _PreconditionChecker = require("../../../utils/PreconditionChecker");

var _OfflineBolt = _interopRequireDefault(require("@material-ui/icons/OfflineBolt"));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var SEEN_TIME = 0;

var NuggetFront = /*#__PURE__*/function (_Kesi2BasicComponent) {
  (0, _inherits2["default"])(NuggetFront, _Kesi2BasicComponent);

  var _super = _createSuper(NuggetFront);

  function NuggetFront(props, context) {
    var _thisSuper, _this;

    (0, _classCallCheck2["default"])(this, NuggetFront);
    _this = _super.call(this, props, context, props.id);
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "renderNewBanner", function () {
      if (_config["default"].storeSeenToContentStore) {
        var seenContents = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.KESI_SEEN_CONTENTS) || {};
        var additionalData = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.KESI_ADDITIONAL_DATA) || {};
        var isUnseen = seenContents && seenContents[_this.props.id] && seenContents[_this.props.id] && (0, _now["default"])() - seenContents[_this.props.id].seen < SEEN_TIME;

        if (_config["default"].isLoggedIn() && (!additionalData[_this.props.id] || additionalData[_this.props.id] && !additionalData[_this.props.id].read) && isUnseen) {
          return /*#__PURE__*/_react["default"].createElement("div", {
            style: {
              position: 'absolute',
              color: 'white',
              backgroundColor: _cssConstants["default"].colors.nuggetUnreadColor,
              top: '10%',
              transform: 'rotate(45deg)',
              right: '-33%',
              padding: '1%',
              zIndex: '10001',
              width: '300px',
              textAlign: 'center',
              border: "3px solid ".concat(_cssConstants["default"].colors.nuggetUnreadColor)
            }
          }, 'Neuer Inhalt');
        }
      }
    });
    _this.state = _objectSpread({
      filePath: _DeviceInfoHelper["default"].isBrowser() ? null : _CordovaFileHelper["default"].getDataFolder(),
      dataUrl: null
    }, _this.state);
    (0, _get2["default"])((_thisSuper = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(NuggetFront.prototype)), "setDataStorePaths", _thisSuper).call(_thisSuper, [_DataStore.DATA_STORE_PATHS.KESI_UPDATE_VALUE, _DataStore.DATA_STORE_PATHS.KESI_ADDITIONAL_DATA, _DataStore.DATA_STORE_PATHS.VB_ACTIVATED, _DataStore.DATA_STORE_PATHS.FFB_EVENTS]);
    _this.isInternetExplorer = _DeviceInfoHelper["default"].isInternetExplorer();
    return _this;
  }

  (0, _createClass2["default"])(NuggetFront, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!_DeviceInfoHelper["default"].isBrowser()) {
        this.loadBackgroundImageAsDataUrl();
      }
    }
  }, {
    key: "loadBackgroundImageAsDataUrl",
    value: function () {
      var _loadBackgroundImageAsDataUrl = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var src, isSvg, isBrowser, prefix, filename, srcToSet;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                src = this.props.backgroundColored || this.props.background;

                if (!(!src || src.indexOf('data') === 0)) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return");

              case 4:
                isSvg = src.indexOf('.svg') >= 0;
                isBrowser = _DeviceInfoHelper["default"].isBrowser();

                if (!(isSvg || _DeviceInfoHelper["default"].isiOS() || _DeviceInfoHelper["default"].isAndroid())) {
                  _context.next = 37;
                  break;
                }

                if (!isBrowser) {
                  _context.next = 11;
                  break;
                }

                _context.t0 = '';
                _context.next = 14;
                break;

              case 11:
                _context.next = 13;
                return _FileSystemWrapper["default"].getPathPrefix();

              case 13:
                _context.t0 = _context.sent;

              case 14:
                prefix = _context.t0;
                filename = src.replace(prefix, '');

                if (!isBrowser) {
                  _context.next = 20;
                  break;
                }

                _context.t1 = filename;
                _context.next = 34;
                break;

              case 20:
                if (!isSvg) {
                  _context.next = 26;
                  break;
                }

                _context.next = 23;
                return _CordovaFileHelper["default"].readTextFile(filename);

              case 23:
                _context.t2 = _context.sent;
                _context.next = 33;
                break;

              case 26:
                _context.t3 = _FileReaderWriterWrapper["default"];
                _context.next = 29;
                return _CordovaFileHelper["default"].getFileEntry(filename, _CordovaFileHelper.LOCAL_FILENAMES.DATA_FOLDER);

              case 29:
                _context.t4 = _context.sent;
                _context.next = 32;
                return _context.t3.readFileAsDataUrl.call(_context.t3, _context.t4);

              case 32:
                _context.t2 = _context.sent;

              case 33:
                _context.t1 = _context.t2;

              case 34:
                srcToSet = _context.t1;
                this.setState({
                  dataUrl: srcToSet
                });
                return _context.abrupt("return");

              case 37:
                this.setState({
                  dataUrl: src
                });
                _context.next = 43;
                break;

              case 40:
                _context.prev = 40;
                _context.t5 = _context["catch"](0);
                console.error('error loading coloured background image', _context.t5);

              case 43:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 40]]);
      }));

      function loadBackgroundImageAsDataUrl() {
        return _loadBackgroundImageAsDataUrl.apply(this, arguments);
      }

      return loadBackgroundImageAsDataUrl;
    }()
  }, {
    key: "getClassNames",
    value: function getClassNames() {
      var classNames = "".concat(_NuggetFront["default"].front);

      if (!this.props.backgroundColor) {
        classNames += " ".concat(this.props.colorClasses ? this.props.colorClasses.backgroundClass : null);
      }

      if (!this.props.isPublished) {
        classNames += " ".concat(_NuggetFront["default"].unpublished);
      }

      if (this.props.glows) {
        classNames += " ".concat(this.props.colorClasses ? this.props.colorClasses.glowClass : null);
      }

      if (this.props.additionalClassName) {
        classNames += " ".concat(this.props.additionalClassName);
      }

      return classNames;
    }
  }, {
    key: "getStyle",
    value: function getStyle() {
      var _backgroundColor;

      var titleSize = _cssConstants["default"].tiles.titleSize + 2;
      var subtitleSize = _cssConstants["default"].tiles.subtitleSize || _cssConstants["default"].tiles.titleSize;
      var titleLineHeight = _cssConstants["default"].tiles.titleLineHeight || titleSize + 2;
      var subtitleLineHeight = subtitleSize + 2;
      var minHeight = _cssConstants["default"].tiles.minTitleHeight;
      var subtitleMinHeight = _cssConstants["default"].tiles.minSubtitleHeight;
      var subtitleHeight = _cssConstants["default"].tiles.subtitleHeight;
      var keywordSize = 12;
      var iconSize = _cssConstants["default"].tiles.iconSize;
      var padding = 10;
      var backgroundMinHeight = _cssConstants["default"].tiles.backgroundHeight;
      var zoomValueToUse = this.props.zoomValue;

      if (_config["default"].targetTileSize) {
        zoomValueToUse = this.props.zoomValue * (_config["default"].targetTileSize / _DrupalNestedTileSizes.TILE_SIZES.LARGE);
      }

      if (this.isInternetExplorer || _config["default"].useZoomForTileFront) {
        titleSize = titleSize * zoomValueToUse;
        subtitleSize = subtitleSize * zoomValueToUse;
        titleLineHeight = titleLineHeight * zoomValueToUse;
        subtitleLineHeight = subtitleLineHeight * zoomValueToUse;
        minHeight = typeof minHeight === 'string' && minHeight.indexOf('%') !== -1 ? _cssConstants["default"].tiles.minTitleHeight : minHeight * zoomValueToUse;
        subtitleMinHeight = subtitleMinHeight * zoomValueToUse;
        subtitleHeight = subtitleHeight * zoomValueToUse;
        keywordSize = keywordSize * zoomValueToUse;
        iconSize = iconSize * zoomValueToUse;
        padding = padding * zoomValueToUse;
        backgroundMinHeight = typeof backgroundMinHeight === 'string' && backgroundMinHeight.indexOf('%') !== -1 ? zoomValueToUse * backgroundMinHeight : "".concat(zoomValueToUse * backgroundMinHeight, "px");
      }

      var backgroundImageBlurred = 'none';

      if (this.hasBackgroundImage()) {
        var img = this.props.backgroundColored || this.props.background;

        if (_DeviceInfoHelper["default"].isBrowser()) {
          backgroundImageBlurred = "url(".concat(img, ")");
        } else {
          backgroundImageBlurred = "url(".concat(this.state.dataUrl, ")");
        }
      }

      var titleBackgroundColor;

      if (_config["default"].useTileBackgroundColorInTile && this.props.forcedUIColor) {
        titleBackgroundColor = this.props.forcedUIColor;
      } else if (_DeviceInfoHelper["default"].isInternetExplorer() && this.props.isGrayScale) {
        titleBackgroundColor = '#a6a6a6';
      } else if (_config["default"].useKeywordAsColor) {
        titleBackgroundColor = this.props.keyword;
      } else if (this.props.titleBackgroundColor) {
        titleBackgroundColor = this.props.titleBackgroundColor;
      } else {
        titleBackgroundColor = _cssConstants["default"].colors.titleBackgroundOverlay;
      }

      var tileBorder;

      if (_config["default"].useTileBackgroundColorInTile && this.props.forcedUIColor && _cssConstants["default"].colors.tileBorderNoColor) {
        tileBorder = "".concat(_cssConstants["default"].colors.tileBorderNoColor).concat(this.props.forcedUIColor);
      } else if (_cssConstants["default"].colors.tileBorder) {
        tileBorder = _cssConstants["default"].colors.tileBorder;
      }

      var backgroundColor = this.props.backgroundColor;

      var ffbEvents = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.FFB_EVENTS);

      if (this.props.keywords && this.props.keywords.indexOf('ffbevent') !== -1 && ffbEvents && ffbEvents.length > 0) {
        var eventMachineArr = this.props.keywords.split('_');

        if (eventMachineArr.length > 1) {
          var machineName = eventMachineArr[1];
          var errorEventName = "".concat(machineName, "_error");

          if (ffbEvents.indexOf(errorEventName.toLowerCase()) !== -1) {
            backgroundColor = '#C3423F';
          }
        }
      }

      var style = {
        keyword: {
          fontSize: keywordSize,
          padding: padding,
          marginRight: iconSize,
          zIndex: 6
        },
        title: {
          fontSize: titleSize,
          padding: padding,
          paddingRight: _config["default"].showArrowOnTile ? padding + 40 : padding,
          lineHeight: "".concat(titleLineHeight, "px"),
          minHeight: minHeight,
          zIndex: 6,
          transform: 'translate3d(0, 0, 0)',
          color: _cssConstants["default"].colors.tileFontColor || '#FFFFFF',
          textTransform: _cssConstants["default"].tiles.textTransform || '',
          fontFamily: _cssConstants["default"].headerFontFamily || null,
          fontWeight: _cssConstants["default"].tiles.tileFontWeight || 500,
          backgroundColor: _cssConstants["default"].colors.titleBackgroundColor || null,
          margin: _cssConstants["default"].tiles.titleMargin || 0
        },
        subtitle: {
          fontSize: subtitleSize,
          height: subtitleHeight,
          lineHeight: "".concat(subtitleLineHeight, "px"),
          minHeight: subtitleMinHeight || null,
          zIndex: 6,
          padding: padding,
          transform: 'translate3d(0, 0, 0)',
          color: _cssConstants["default"].colors.tileSubtitleColor || _cssConstants["default"].colors.tileFontColor,
          bottom: _cssConstants["default"].tiles.subtitleBottom || '0px',
          fontWeight: _cssConstants["default"].tiles.tileSubtitleFontWeight || null
        },
        titleBackground: {
          width: '100%',
          minHeight: backgroundMinHeight,
          overflow: 'hidden',
          zIndex: 5
        },
        titleBackgroundBlur: {
          filter: this.props.background ? _cssConstants["default"].tiles.blur : 'blur(0)',
          // normal, erv: 'blur(12px)',
          backgroundImage: backgroundImageBlurred,
          zIndex: 6,
          backgroundSize: '100% 100%',
          height: this.props.correctedSize + 'px',
          width: '100%',
          transform: 'translate3d(0, 0, 0)',
          backgroundColor: _cssConstants["default"].tiles.backgroundColor,
          margin: _cssConstants["default"].tiles.margin
        },
        titleBackgroundOverlay: {
          backgroundColor: backgroundColor || titleBackgroundColor,
          opacity: _cssConstants["default"].tiles.backgroundOverlayOpacity || null,
          zIndex: 6,
          height: '100%',
          width: '100%',
          transform: 'translate3d(0, 0, 0)',
          borderRadius: _cssConstants["default"].tiles.titleBackgroundBorderRadius || 0
        },
        icon: {
          height: 'auto',
          maxHeight: _cssConstants["default"].tiles.iconMaxHeight || '100%',
          verticalAlign: 'middle',
          zIndex: 6,
          position: 'relative',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)',
          margin: _cssConstants["default"].tiles.iconMargin || '0 auto',
          display: 'block'
        },
        messageContainer: {
          zIndex: 6,
          left: '10px',
          top: '10px',
          position: 'absolute'
        },
        iconContainer: {
          height: _cssConstants["default"].tiles.iconContainerHeight || "".concat(this.isInternetExplorer ? (this.props.correctedSize - _cssConstants["default"].tiles.backgroundHeight - 40) * zoomValueToUse : this.props.correctedSize - _cssConstants["default"].tiles.backgroundHeight - 40, "px"),
          zIndex: 6,
          width: _cssConstants["default"].tiles.iconContainerWidth || '100%',
          position: _cssConstants["default"].tiles.iconContainerPosition || null,
          right: _cssConstants["default"].tiles.iconContainerRight || null,
          top: _cssConstants["default"].tiles.iconContainerTop || null,
          borderRadius: _cssConstants["default"].tiles.iconContainerBorderRadius || null,
          backgroundColor: _cssConstants["default"].tiles.iconContainerBackground || null
        },
        background: {
          width: '100%',
          height: '100%',
          zIndex: 3
        },
        front: {
          overflow: 'hidden',
          border: tileBorder,
          backgroundColor: (_backgroundColor = backgroundColor) !== null && _backgroundColor !== void 0 ? _backgroundColor : null
        },
        arrow: {
          height: titleSize - 1,
          width: titleSize - 1,
          paddingLeft: 10
        },
        progressBar: {
          height: '28px',
          borderRadius: '14px',
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          zIndex: 20,
          overflow: 'hidden'
        },
        progressBarInner: {
          height: '28px',
          transform: 'skewX(20deg)',
          zIndex: 1,
          left: '-10px',
          top: 0,
          position: 'absolute'
        }
      };

      if (_cssConstants["default"].tiles.titleStyle) {
        style.title = (0, _assign["default"])(style.title, _cssConstants["default"].tiles.titleStyle);
      }

      if (_cssConstants["default"].tiles.subtitleStyle) {
        style.subtitle = (0, _assign["default"])(style.subtitle, _cssConstants["default"].tiles.subtitleStyle);
      }

      if (_cssConstants["default"].tiles.iconStyle) {
        style.icon = (0, _assign["default"])(style.icon, _cssConstants["default"].tiles.iconStyle);
      }

      if (_cssConstants["default"].tiles.titleBackgroundStyle) {
        style.titleBackground = (0, _assign["default"])(style.titleBackground, _cssConstants["default"].tiles.titleBackgroundStyle);
      }

      if (_cssConstants["default"].tiles.titleBackgroundBlurStyle) {
        style.titleBackgroundBlur = (0, _assign["default"])(style.titleBackgroundBlur, _cssConstants["default"].tiles.titleBackgroundBlurStyle);
      }

      if (_cssConstants["default"].tiles.titleBackgroundOverlayStyle) {
        style.titleBackgroundOverlay = (0, _assign["default"])(style.titleBackgroundOverlay, _cssConstants["default"].tiles.titleBackgroundOverlayStyle);
      }

      if (_cssConstants["default"].tiles.iconContainerStyle) {
        style.iconContainer = (0, _assign["default"])(style.iconContainer, _cssConstants["default"].tiles.iconContainerStyle);
      }

      if (_cssConstants["default"].tiles.backgroundStyle) {
        style.background = (0, _assign["default"])(style.background, _cssConstants["default"].tiles.backgroundStyle);
      }

      if (_cssConstants["default"].tiles.frontStyle) {
        style.front = (0, _assign["default"])(style.front, _cssConstants["default"].tiles.frontStyle);
      }

      if (_cssConstants["default"].tiles.arrowStyle) {
        style.arrow = (0, _assign["default"])(style.arrow, _cssConstants["default"].tiles.arrowStyle);
      }

      if (_cssConstants["default"].tiles.progressBarStyle) {
        style.progressBar = (0, _assign["default"])(style.progressBar, _cssConstants["default"].tiles.progressBarStyle);
      }

      if (_cssConstants["default"].tiles.progressBarInnerStyle) {
        style.progressBarInner = (0, _assign["default"])(style.progressBarInner, _cssConstants["default"].tiles.progressBarInnerStyle);
      }

      return style;
    }
  }, {
    key: "hasBackgroundImage",
    value: function hasBackgroundImage() {
      if (_DeviceInfoHelper["default"].isBrowser()) return this.props.background;
      return this.state.filePath && this.props.background;
    }
  }, {
    key: "hasIcon",
    value: function hasIcon() {
      if (_DeviceInfoHelper["default"].isBrowser()) return this.props.icon;
      return this.state.filePath && this.props.icon;
    }
  }, {
    key: "renderBadge",
    value: function renderBadge(read) {
      if (_config["default"].targetTag === 'i40') {
        var failureActive = _DataStore["default"].getElementByPathImmediately('private.i40.failureActive');

        if (failureActive) {
          //id 30 || 16 =3
          // id 39 = 1
          // id 43 = blitz
          if (this.props.id === '43') {
            return /*#__PURE__*/_react["default"].createElement(_OfflineBolt["default"], {
              style: {
                backgroundColor: 'white',
                color: 'red',
                height: 30,
                zIndex: 600,
                width: 30,
                position: 'absolute',
                right: 10,
                borderRadius: '50%',
                top: 10,
                transform: 'translate3d(0, 0, 0)'
              }
            });
          }

          var counter = null;
          if (this.props.id === '30' || this.props.id === '16') counter = '3';else if (this.props.id === '39') counter = '1';

          if (counter) {
            return /*#__PURE__*/_react["default"].createElement("div", {
              style: {
                backgroundColor: 'red',
                color: 'white',
                height: 30,
                zIndex: 600,
                width: 30,
                position: 'absolute',
                right: 10,
                borderRadius: '50%',
                top: 10,
                transform: 'translate3d(0, 0, 0)'
              }
            }, /*#__PURE__*/_react["default"].createElement("div", {
              style: {
                color: 'white',
                fontSize: '25px',
                position: 'absolute',
                left: '50%',
                top: '50%',
                transform: 'translate(-50%, -50%)'
              }
            }, counter));
          }
        }
      }

      return !read && _config["default"].showBadgeOnUnreadLectures && /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          backgroundColor: 'red',
          height: 20,
          zIndex: 600,
          width: 20,
          position: 'absolute',
          right: 10,
          borderRadius: '50%',
          top: 10,
          transform: 'translate3d(0, 0, 0)'
        }
      });
    }
  }, {
    key: "renderIcon",
    value: function renderIcon(style, isLocked) {
      if (!this.hasIcon()) return null;
      var path = _DeviceInfoHelper["default"].isBrowser() ? this.props.icon : "".concat(this.state.filePath).concat(this.props.icon);

      var icon = /*#__PURE__*/_react["default"].createElement(_Image["default"], {
        alt: this.props.enhancedIcon && this.props.enhancedIcon.alt ? this.props.enhancedIcon.alt : 'Themenicon',
        src: path,
        style: style.icon,
        className: _NuggetFront["default"].icon
      });

      if (isLocked) {
        style.icon.left = '25%';
        icon = /*#__PURE__*/_react["default"].createElement(_Image["default"], {
          alt: 'Schlosssymbol',
          src: _config["default"].lockIcon,
          style: style.icon,
          className: _NuggetFront["default"].lockedIcon
        });
      }

      return this.hasIcon() && /*#__PURE__*/_react["default"].createElement("div", {
        style: style.iconContainer,
        className: _NuggetFront["default"].iconContainer
      }, icon);
    }
  }, {
    key: "renderBackground",
    value: function renderBackground(style, keyword, isLocked) {
      var path = _DeviceInfoHelper["default"].isBrowser() ? this.props.background : "".concat(this.state.filePath).concat(this.props.background);

      if (isLocked && style.background) {
        style.background.filter = 'grayscale(1) brightness(1.2)';
      }

      var img = this.hasBackgroundImage() && /*#__PURE__*/_react["default"].createElement(_Image["default"], {
        src: path,
        alt: this.props.enhancedBackground ? this.props.enhancedBackground.alt : '',
        style: style.background,
        className: "".concat(_DeviceInfoHelper["default"].isInternetExplorer() && this.props.isGrayScale ? _NuggetFront["default"].backgroundIE : _NuggetFront["default"].background, " tileBackground")
      });

      return /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          height: '100%',
          width: '100%'
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          height: '100%',
          width: '100%'
        },
        className: _config["default"].useTileZoom && keyword !== _DrupalNestedTileSizes.LANDSCAPE_FULL ? "".concat(_NuggetFront["default"].backgroundContainer, " tileBackgroundContainer") : 'tileBackgroundContainer'
      }, img, this.props.enhancedBackground && this.props.enhancedBackground.copyright && /*#__PURE__*/_react["default"].createElement("div", {
        className: _NuggetFront["default"].background,
        style: style.background
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(_NuggetFront["default"].backgroundCopyright, " copyright")
      }, this.props.enhancedBackground.copyright))), keyword !== _DrupalNestedTileSizes.LANDSCAPE_FULL && !(_config["default"].useBackgroundImageTitle && img) && /*#__PURE__*/_react["default"].createElement("div", {
        className: _NuggetFront["default"].titleBackground,
        style: style.titleBackground
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _NuggetFront["default"].titleBackgroundBlur,
        style: style.titleBackgroundBlur
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: _NuggetFront["default"].titleBackgroundOverlay,
        style: style.titleBackgroundOverlay
      })));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var style = this.getStyle();
      var fav = false;
      var read = false;
      var percentage = 0;

      var additionalData = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.KESI_ADDITIONAL_DATA);

      if (additionalData && additionalData[this.props.id]) {
        fav = additionalData[this.props.id].favorite;
      }

      percentage = _KESI2Helper["default"].getPercentageForContent(this.props.id);
      read = percentage >= 99; // || notMandatory

      if (additionalData && additionalData[this.props.id] && additionalData[this.props.id].read !== true && read) {
        _KESI2Helper["default"].setReadForId(this.props.id, true);
      }

      var content = _KESI2Helper["default"].getContentById(this.props.id);

      var failingPrecondition;

      if (content && content.openPrecondition) {
        failingPrecondition = (0, _PreconditionChecker.getFailingPrecondition)(content.openPrecondition);
      }

      var percentageInfo = null;

      if (_config["default"].renderProgressBarOnTile) {
        if (percentage >= 99) {
          percentageInfo = /*#__PURE__*/_react["default"].createElement("p", null, "Bereits absolviert");
        } else if (percentage > 0) {
          percentageInfo = /*#__PURE__*/_react["default"].createElement("p", null, "Machen Sie weiter");
        } else {
          percentageInfo = failingPrecondition ? /*#__PURE__*/_react["default"].createElement("p", null, "Loggen Sie sich ein") : /*#__PURE__*/_react["default"].createElement("p", {
            style: {
              color: 'black'
            }
          }, 'Legen Sie los');
        }
      }

      var isLocked = !!_config["default"].lockIcon && !!failingPrecondition;

      if (_config["default"].hideFlippedTileBackground && this.props.parentHasOpenTile) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: this.getClassNames(),
          style: style.front
        });
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: this.getClassNames(),
        style: style.front
      }, this.renderBackground(style, this.props.keywords, isLocked), _config["default"].renderProgressBarOnTile && /*#__PURE__*/_react["default"].createElement("div", {
        style: style.progressBar
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          position: 'absolute',
          zIndex: 4,
          left: 10,
          top: 2,
          width: '100%',
          height: '28px'
        }
      }, percentageInfo), /*#__PURE__*/_react["default"].createElement("div", {
        className: 'doNotInvert',
        style: (0, _assign["default"])(style.progressBarInner, {
          width: percentage === 100 ? "calc((100% * ".concat(percentage / 100, ") + 20px)") : "calc((100% * ".concat(percentage / 100, ") + 5px)")
        })
      })), !(_config["default"].useBackgroundImageTitle && this.hasBackgroundImage()) && this.props.keywords !== _DrupalNestedTileSizes.LANDSCAPE_FULL && /*#__PURE__*/_react["default"].createElement("div", {
        className: _NuggetFront["default"].title,
        style: style.title
      }, this.props.title, _config["default"].addSubtitleToTitleField && /*#__PURE__*/_react["default"].createElement("div", {
        className: _NuggetFront["default"].subtitle,
        style: style.subtitle
      }, this.props.subtitle)), _config["default"].showSubtitleOnTile && !_config["default"].addSubtitleToTitleField && this.props.keywords !== _DrupalNestedTileSizes.LANDSCAPE_FULL && /*#__PURE__*/_react["default"].createElement("div", {
        className: _NuggetFront["default"].subtitle,
        style: style.subtitle
      }, this.props.subtitle), this.props.processTime && this.props.processTime > 0 ? /*#__PURE__*/_react["default"].createElement("div", {
        className: _NuggetFront["default"].containerLeft,
        style: _config["default"].useBackgroundImageTitle && this.hasBackgroundImage() ? {
          color: this.props.backgroundColor
        } : {
          color: _cssConstants["default"].colors.tileFontColor
        }
      }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
        name: "clock-o"
      }), /*#__PURE__*/_react["default"].createElement("b", null, "\xA0", this.props.processTime, "\u2019")) : null, /*#__PURE__*/_react["default"].createElement("div", {
        id: "NuggetFrontInjection",
        className: _NuggetFront["default"].injectionContainer
      }, _config["default"].NuggetFrontInjection(this.props)), (_config["default"].showFav || _config["default"].showRead) && /*#__PURE__*/_react["default"].createElement("div", {
        className: _NuggetFront["default"].containerRight,
        style: this.isInternetExplorer ? {
          bottom: "".concat(10 * this.props.zoomValue, "px"),
          right: "".concat(10 * this.props.zoomValue, "px"),
          fontSize: "".concat(20 * this.props.zoomValue, "px")
        } : {
          bottom: '13px',
          right: '10px',
          fontSize: '20px'
        }
      }, _config["default"].showFav && this.props.type !== 'spoc' && /*#__PURE__*/_react["default"].createElement("div", {
        className: _NuggetFront["default"].favIcon,
        style: this.isInternetExplorer ? {
          marginRight: "".concat(10 * this.props.zoomValue, "px")
        } : {
          marginRight: '10px'
        },
        onClick: /*#__PURE__*/function () {
          var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(e) {
            return _regenerator["default"].wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    e.stopPropagation();
                    _context2.next = 3;
                    return _KESI2Helper["default"].setFavoriteForLectureId(_this2.props.id, !fav);

                  case 3:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2);
          }));

          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }()
      }, fav ? /*#__PURE__*/_react["default"].createElement("img", {
        alt: 'Lesezeichenicon',
        style: this.isInternetExplorer ? {
          height: "".concat(24 * this.props.zoomValue, "px")
        } : {
          height: '24px'
        },
        src: _config["default"].bookmarkIconTrueTile
      }) : /*#__PURE__*/_react["default"].createElement("img", {
        alt: 'Lesezeichenicon',
        style: this.isInternetExplorer ? {
          height: "".concat(24 * this.props.zoomValue, "px")
        } : {
          height: '24px'
        },
        src: _config["default"].bookmarkIconFalseTile
      })), _config["default"].showRead && /*#__PURE__*/_react["default"].createElement("div", {
        className: _NuggetFront["default"].readIcon
      }, _KESI2Helper["default"].checkIfOnlyNotMandatoryNuggets(this.props.id) || read ? /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
        name: "check-circle"
      }) : /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
        name: "circle-o"
      }))), _config["default"].showArrowOnTile && /*#__PURE__*/_react["default"].createElement("div", {
        className: _NuggetFront["default"].tileArrow,
        style: this.isInternetExplorer ? {
          height: "".concat(40 * this.props.zoomValue, "px"),
          width: "".concat(40 * this.props.zoomValue, "px")
        } : {
          height: '40px',
          width: '40px'
        }
      }, /*#__PURE__*/_react["default"].createElement("img", {
        alt: 'Weiterpfeil',
        src: require('./assets/keyboard_right.png'),
        className: _NuggetFront["default"].arrowIcon
      })), _config["default"].addArrowToTileTitle ? /*#__PURE__*/_react["default"].createElement(_Image["default"], {
        alt: 'Weiterpfeil',
        src: _config["default"].titleArrow,
        style: style.arrow
      }) : null, this.renderIcon(style, isLocked), this.renderBadge(read), this.renderNewBanner());
    }
  }]);
  return NuggetFront;
}(_KESI2BasicComponent["default"]);

NuggetFront.propTypes = {
  id: _propTypes["default"].string.isRequired,
  glows: _propTypes["default"].bool.isRequired,
  keywords: _propTypes["default"].string,
  icon: _propTypes["default"].string,
  background: _propTypes["default"].string,
  backgroundColor: _propTypes["default"].string,
  title: _propTypes["default"].string.isRequired,
  subtitle: _propTypes["default"].string,
  colorClasses: _propTypes["default"].shape({
    backgroundClass: _propTypes["default"].string,
    glowClass: _propTypes["default"].string
  }),
  zoomValue: _propTypes["default"].number.isRequired,
  size: _propTypes["default"].number.isRequired,
  correctedSize: _propTypes["default"].number,
  type: _propTypes["default"].string,
  processTime: _propTypes["default"].number,
  isGrayScale: _propTypes["default"].bool,
  forcedUIColor: _propTypes["default"].string,
  isPublished: _propTypes["default"].bool,
  parentHasOpenTile: _propTypes["default"].bool
};
var _default = NuggetFront;
exports["default"] = _default;